import { Link } from 'react-router-dom';

export default function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div>
          <p className="site-footer__brand">Atlas Creative Labs</p>
          <p className="site-footer__summary">Veteran-owned • Built in Maine</p>
          <p className="site-footer__summary">Technology should simplify people's lives instead of making them more complicated.</p>
        </div>

        <nav aria-label="Footer navigation" className="site-footer__links">
          <Link to="/atlas">Atlas</Link>
          <Link to="/applications">Future Apps</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/about">About</Link>
          <Link to="/pre-alpha">Pre-Alpha</Link>
          <Link to="/contact">Contact</Link>
        </nav>
      </div>
    </footer>
  );
}
